import { gql } from '@apollo/client';

export const GET_TASK_LIST_ASSIGNED_USERS = gql`
  query GetTaskListAssignedUsers($id: ID!) {
    viewer {
      __typename
      id
      company {
        __typename
        id
        featureSet {
          __typename
          checklistAssignment
        }
      }
      taskList(id: $id) {
        id
        __typename
        assignedUsers {
          __typename
          nodes {
            id
            avatar
            emailAddress
            firstName
            lastName
            initials
            name
          }
        }
      }
    }
  }
`;
